import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import bg from "src/assets/img/bg.png";
import bg_img from "src/assets/img/55.png";
import age from "src/assets/img/age-xml-icon_18.png"
import { getDomainMeta } from "src/themes";

const FooterSection = () => {
  const domainMeta = getDomainMeta();
  const { t } = useTranslation();
  return (
    <div className="">
      <main className=" mx-auto  overflow-hidden">
        <section
          className="hero h-[840px] bg-hero bg-center lg:bg-cover bg-no-repeat"
          style={{ backgroundImage: `url(${bg})` }}
        >
          <div className="max-w-[1000px] mx-auto ">
            <div class="flex gap-4  md:gap-10 flex-col md:flex-row md:p-12">
              <div class="md:w-1/2  flex flex-col space-y-11 justify-center">
                <div class="md:text-4xl text-2xl font-bold mt-6 md:mt-0">
                  <h1 className="text-center md:text-start">
                   {t("Enjoy the Datertainment of the Future! Get with")}
                    <span className="text-[#FF005C]"> {`${domainMeta.main_heading}`}</span>{" "}
                   {t("Access to Events and exclusive Medias")}
                  </h1>
                </div>
              </div>
              <div class="flex md:justify-end w-full md:w-1/2 ">
                <div class="">
                  <div class=" z-10 ">
                    <div className="">
                      <div className="">
                        <div className="mb-7">
                          <img
                            src={bg_img}
                            alt=""
                            className=" object-cover h-full w-full"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <footer className="bg-white">
        <div className="flex flex-col mx-3 bg-white rounded-lg">
          <div className="w-full draggable">
            <div className="container flex flex-col mx-auto">
              <div className="flex flex-col items-center w-full">
                <span className="mb-8"></span>
                <div className="flex flex-col items-center gap-6 mb-8">
                  <div className="flex flex-wrap items-center justify-center gap-5 lg:gap-12 gap-y-3 lg:flex-nowrap text-dark-grey-900">
                    <Link
                      to="/imprint"
                      className="text-gray-600 hover:text-gray-900"
                    >
                      {t("Impressum")}{" "}
                    </Link>
                    <Link
                      to="/privacy"
                      className="text-gray-600 hover:text-gray-900"
                    >
                      {t("Datenschutz")}
                    </Link>
                    <Link
                      to="/terms"
                      className="text-gray-600 hover:text-gray-900"
                    >
                      {t("AGB")}
                    </Link>
                    <Link
                      to="/customer"
                      className="text-gray-600 hover:text-gray-900"
                    >
                      {t("Kundensupport")}
                    </Link>
                  </div>
                  {/* <div className="flex items-center gap-8">
                    <a
                      href="https://web.facebook.com/flirttoolprime?_rdc=1&_rdr"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mx-3 transition-colors duration-300"
                    >
                      <i className="fab fa-facebook text-2xl"></i>
                    </a>

                    <a
                      href="https://www.instagram.com/flirttoolprime/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mx-3 transition-colors duration-300"
                    >
                      <i className="fab fa-instagram text-2xl"></i>
                    </a>
                    <img src={age} alt="" className="cursor-pointer bg-cover w-32"/>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full md:w-3/4 mx-auto text-center mx-2 ">
          <p className="text-sm text-slate-500 py-1 mx-2 ">{t("footerNote")}</p>
        </div>
      </footer>
    </div>
  );
};

export default FooterSection;
